import dayjs from 'dayjs';

export const isChristmasTime = () => {
  const now = dayjs();
  return now.isAfter(dayjs(`${dayjs(now).year()}-12-20`)) && now.isBefore(dayjs(`${dayjs(now).year() + 1}-01-09`));
};
